<template>
<div class="chapter">
<div class="inner_page">
<p class="P_WFP_ChapHead" id="auto_bookmark_table_of_contents_1"><span>Dedication</span></p>
<p class="P_WFP_BodyText__And__Italic__And__Centre_Alignment"><span>To the 33 United States Air Force Academy graduates</span></p>
<p class="P_WFP_BodyText__And__Italic__And__Centre_Alignment"><span>who were Southeast Asia Prisoners of War;</span></p>
<p class="P_WFP_BodyText__And__Italic__And__Centre_Alignment"><span>their goal and motto was to</span></p>
<p class="P_WFP_BodyText__And__Centre_Alignment"><span><i>“Return with Honor.”</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0004.vue?4540e92c